module.exports = __webpack_public_path__ + "media/images/icon__warning@3x-f5dfaeaf62a06f1efda90d4f2ac0bed6.png";